import React from "react";
import { Row, Dropdown, Menu } from "antd";
import { CaretDownOutlined, UserOutlined } from "@ant-design/icons";
import "./style.scss";
import icon from "assets/sandwich-icon.png";
import { Link } from "react-router-dom";
import { IDefaultHeader, IGeneralState } from "types";
import { useSelector } from "react-redux";
import { getItem } from "utils/getItem";

export const DefaultHeader: React.FC<IDefaultHeader> = (props) => {
	const { setIsCollapsed, isCollapsed } = props;
	const { name, label } = useSelector((state: IGeneralState) => state.app.user);
	const isManager = label === "manager";

	const itemsManager = [
		getItem(
			<Link
				style={{ fontWeight: "bold" }}
				rel="noopener noreferrer"
				to="/login"
				onClick={() => localStorage.removeItem("token")}
			>
				Sair
			</Link>,
			"1",
			true
		),
	];

	const itemsStudent = [
		getItem(
			<Link className="header__dropdown-item" to="/my-courses">
				Meus cursos
			</Link>,
			"1"
		),
		getItem(
			<Link
				style={{ fontWeight: "bold" }}
				rel="noopener noreferrer"
				to="/login"
				onClick={() => localStorage.removeItem("token")}
			>
				Sair
			</Link>,
			"2",
			true
		),
	];

	// const items: MenuItem[] = isManager ? itemsManager : itemsStudent;

	const menu = <Menu items={isManager ? itemsManager : itemsStudent} />;

	return (
		<div style={{ width: "100%" }}>
			<Row className="header">
				<button className="z-3 collapse-btn" onClick={() => setIsCollapsed(!isCollapsed)}>
					<img src={icon} alt="icon" />
				</button>
				<Dropdown overlay={menu}>
					<div className="header__user">
						<div className="header__user__label">
							<p>Olá,</p>
							<p>
								<b>{name}</b>
							</p>
						</div>
						<div className="circle">
							<UserOutlined twoToneColor="#000" />
						</div>
						<CaretDownOutlined />
					</div>
				</Dropdown>
			</Row>
		</div>
	);
};
